export default __webpack_public_path__ + "static/media/CastelfrancoContrasto.b92ba99b.webp";